import { render, staticRenderFns } from "./activatePage.vue?vue&type=template&id=36932996&"
import script from "./activatePage.vue?vue&type=script&lang=ts&"
export * from "./activatePage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../wellness/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports